import { PATHS } from "@constants/Paths";
/**
 * The paths our sidebar and pages link to, built in one place instead of inline at each call.
 *
 * They are deliberately unprefixed: the `/o/:orgId` segment is added by the caller through
 * `useOrgPath()`, which knows whether there is an active organization at all — staff read these
 * same pages on the unprefixed URLs.
 */
export const communityPath = (communityId) => PATHS.COMMUNITY.replace(":communityId", communityId);
export const reportPath = (assessmentId) => PATHS.OVERVIEW.replace(":assessmentId", assessmentId);
export const topicsAndSourcesPath = (assessmentId) => PATHS.RESULTS.replace(":assessmentId", assessmentId);
